/**
 * SuperAdmin pricing & billing — /superadmin/pricing (route shell).
 *
 * Screen impl in `./pricing-screen.tsx`, lazy-loaded. Platform-operator-only
 * surface (behind the /superadmin layout gate).
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/superadmin/pricing')({
  component: lazyRouteComponent(() => import('./pricing-screen'), 'PricingBillingPage'),
});
